import script from "./FormFiltroPeriodo.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFiltroPeriodo.vue?vue&type=script&setup=true&lang=js"

import "./FormFiltroPeriodo.vue?vue&type=style&index=0&id=bc4bb500&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc4bb500"]])

export default __exports__